import { FC, Fragment } from "react";
import { LocalParticipantContextProvider } from "./LocalParticipantContext";
import { RemoteParticipantContextProvider } from "./RemoteParticipantContext";

export const ParticipantsContextProvider= ({ children }: { children: any }) => {
  return (
    <Fragment>
      <LocalParticipantContextProvider>
        <RemoteParticipantContextProvider>
          {children}
        </RemoteParticipantContextProvider>
      </LocalParticipantContextProvider>
    </Fragment>
  );
};
